<template>
  <BaseModal
    data-cy="imageGalleryModal"
    :title="title"
    hide-save
    go-back-mode
    @close="() => cancel()"
  >
    <template #cta>
      <ion-buttons class="justify-end">
        <!-- <ion-button
          v-if="onAddMore && !isReadonly"
          data-cy="addResources"
          @click="onAddMore()"
        >
          <ion-icon
            slot="icon-only"
            :icon="addCircleOutline"
          />
        </ion-button> -->
        <!-- Buttons for powerpole view start -->
        <!-- the editing button is commented out, since it currently doesnt work and as far as i know isnt needed 
             for pictures in the powerpole view(look at MS 676 / MS 963)-->
        <!--
        <ion-button
          v-if="!inSurveyMode"
          :title="$t('hzba.buttons.tooltips.editImage')"
          @click="openImageEditorModal(selectedImage)"
        >
          <ion-icon slot="icon-only" :icon="createSharp" />
        </ion-button> 
        -->
        <ion-button
          v-if="onDelete && !isReadonly && !inSurveyMode"
          data-cy="button-delete-photo"
          :title="$t('hzba.buttons.tooltips.deleteImage')"
          @click="deleteImage(selectedImage)"
        >
          <ion-icon slot="icon-only" :icon="trashOutline" />
        </ion-button>
        <ion-button
          v-if="downloadEnabled && !inSurveyMode"
          data-cy="downloadResource"
          :title="$t('hzba.buttons.tooltips.downloadImage')"
          @click="() => downloadResource(selectedImage)"
        >
          <ion-icon slot="icon-only" :icon="canShare ? share : download"/>
        </ion-button> 
        <!-- Buttons for powerpole view end -->

        <!-- Download for the survey -->
        <ion-button
          v-if="downloadEnabled && inSurveyMode"
          data-cy="downloadResources"
          :title="$t('hzba.buttons.tooltips.downloadAllImages')"
          @click="downloadResources"
        >
          <ion-icon slot="icon-only" :icon="canShare ? share : download" />
        </ion-button> 
      </ion-buttons>
    </template>

    <ion-content
      ref="content"
      data-cy="imageGalleryContent"
    >
      <div class="my-4">
        <OfflineHint>
          {{ $t('immobilie.images.offlineHint') }}
        </OfflineHint>
        <div
          v-for="(photo, key) in imagesToDisplay"
          :id="`photo-${key}`"
          :key="photo"
          class="px-4 pt-4"
          :data-cy="`photo-${key}`"
            @click="selectImage(photo)"
        >
          <div class="block lg:flex">
            <a-image
              :src="getPhotoUrl(photo)"
              :image-class="'w-full h-auto'"
              :data-cy="`image-${key}`"
            /> <!-- min-h-96 -->
            <!--            <ion-img :src="getPhotoUrl(photo)" />-->

            <div class="flex lg:flex-col" v-if="inSurveyMode">      
              <ion-button
                v-if="onDelete && !isReadonly"
                data-cy="button-delete-photo"
                class="lg:ml-2"
                :title="$t('hzba.buttons.tooltips.deleteImage')"
                @click="deleteImage(photo)"
              >
                <ion-icon slot="icon-only" :icon="trashOutline" />
              </ion-button>
              <ion-button
                v-if="downloadEnabled"
                class="lg:ml-2"
                :title="$t('hzba.buttons.tooltips.downloadImage')"
                @click="() => downloadResource(photo)"
              >
                <ion-icon
                  slot="icon-only"
                  :icon="canShare ? share : download"
                />
              </ion-button>
              <ion-button
                class="lg:ml-2"
                :title="$t('hzba.buttons.tooltips.editImage')"
                @click="openImageEditorModal(photo)"
              >
                <ion-icon slot="icon-only" :icon="createSharp" />
              </ion-button>        
            </div>
          </div>
          <!-- <ion-button
            v-if="!!allowAddMore"
          >Weitere Fotos hinzufügen
        </ion-button> -->
        </div>
      </div>
    </ion-content>
  </BaseModal>
</template>

<script lang="ts">

import { download, share, addCircleOutline, trashOutline, createSharp } from "ionicons/icons";
import BaseModal from "@/components/Base/BaseModal";
import useBaseModal from "@/composables/useModal";
import { IonImg, IonContent, IonButtons, IonButton, IonIcon, modalController } from "@ionic/vue";
import { getPhotoUrl } from "@/utilities/get-media-url";
import {computed, onMounted, ref, watch} from "vue";
import AImage from "@/components/Base/AImage";
import useDownloadHelper from "@/composables/useDownloadHelper";
import OfflineHint from "../Other/OfflineHint.vue";
import { useStore } from "@/composables/useTypedStore";
import StrapiMedia from "@/models/photo/strapi-media.model";
import ImageEditor from "@/components/v2/App/ImageEditor.vue";

export default {
  name: "ImageGalleryModal",
  components: {AImage, BaseModal, IonImg, IonContent, IonButton, IonButtons, IonIcon, OfflineHint },
  props: {
    title: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: undefined
    },
    onDelete: {
      type: Function,
      default: undefined,
    },
    onEdited: {
      type: Function,
      default: undefined,
    },    
    allowAddMore: {
      type: Boolean,
      default: false
    },
    // addImmoPhoto: {
    //   type: Function,
    //   default: undefined
    // },
    isReadonly: {
      type: Boolean,
      default: false   
    },
    downloadEnabled: {
      type: Boolean,
      default: false,
    },
    deleteLocally: {
      type: Boolean,
      default: false
    },
    inSurveyMode: {
      type: Boolean,
      default:false
    }
  },
  emits: ['close', 'save'],
  setup(props: any) {
    const content = ref();
    const { defaultCancel } = useBaseModal();
    const updatedImages = ref(props.images);
    const store = useStore();

    const { canShare, downloadFile, isProcessing } = useDownloadHelper();

    const isOffline = computed(() => {
      return store.getters['app/isOffline']
    })
    const isMobile = computed(() => {
        return store.getters["app/isMobile"];
      });
    const selectedImage = ref(props.images[props.index ?? 0] ?? null);
    function selectImage(photo: any) {
      selectedImage.value = photo;
    }
    async function scrollToIndex() {
      const scrollEl = await content.value.$el.getScrollElement();

      const el = document.getElementById(`photo-${props.index}`)
      scrollEl.scrollTo({ top: el?.offsetTop, behavior: 'smooth' })
    }


    onMounted(async () => {

      setTimeout(() => {
        if (props.index) {
          scrollToIndex();
        }
      }, 700)
    })

    function downloadResource(photo: any) {
      downloadFile(""+getPhotoUrl(photo), photo.name || 'image');
    }

    function downloadResources() {
      updatedImages.value.forEach((el: any) => {
        downloadResource(el);
      })
    }

    async function deleteImage(photo: any) {
      if (props.onDelete) {
        const success = await props.onDelete(photo);
        if (props.deleteLocally && success) {
          if (photo.id) {
            updatedImages.value = updatedImages.value.filter((img: any) => img.id !== photo.id);
          } else if (photo.webPath) {
            updatedImages.value = updatedImages.value.filter((img: any) => img.webPath !== photo.webPath);
          }
        }
      }
    }

    watch(() => props.images, (newVal) => {
      updatedImages.value = newVal;
    });

    const imagesToDisplay = computed(() => {
      return isOffline.value ? updatedImages.value.filter((img: any) => img.webPath) : updatedImages.value;
    });

    async function openImageEditorModal(image: StrapiMedia | Blob) {
        const modal = await modalController.create({
            component: ImageEditor,
            cssClass: 'fullScreenModal',
            componentProps: {
              image,
              isMobile: isMobile.value,
            },
            canDismiss: true,
        });
        modal.onDidDismiss().then((data: any) => {
            if (data.role !== 'save' || props.onEdited === undefined) {
                return;
            }
            props.onEdited(data.data.oldId, data.data.newImg);
    });

    return modal.present();
}

    return {
      cancel: defaultCancel,
      canShare,
      getPhotoUrl,
      content,
      trashOutline,
      downloadResource,
      downloadResources,
      download,
      share,
      addCircleOutline,
      imagesToDisplay,
      deleteImage,
      createSharp,
      openImageEditorModal,
      selectedImage,
      selectImage
    }
  }
}
</script>

<style scoped lang="scss">

ion-icon {
  color: var(--white100);
}

ion-button {
  color: var(--white100);
}

</style>